// extracted by mini-css-extract-plugin
export default {"main":"Sheet_main__GqJhj","avatar":"Sheet_avatar__QnjOU","image":"Sheet_image__PHEiA","name":"Sheet_name__qrMVJ","sheet":"Sheet_sheet__qiQy4"};